/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ParishListResponseDto } from '../../models/parish-list-response-dto';

export interface GetParishList$Params {}

export function getParishList(
  http: HttpClient,
  rootUrl: string,
  params?: GetParishList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ParishListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getParishList.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParishListResponseDto>;
      }),
    );
}

getParishList.PATH = '/parish';
